(() => {
  let library;
  const loadViewer = () => {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (!library) library = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.3.1/model-viewer.min.js';
      script.onload = () => customElements.whenDefined('model-viewer').then(resolve);
      script.onerror = () => { library = null; script.remove(); reject(new Error('Viewer unavailable')); };
      document.head.append(script);
    });
    return library;
  };
  const init = (root = document) => root.querySelectorAll('[data-al-study]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const button = section.querySelector('[data-al-study-open]');
    const poster = section.querySelector('[data-al-study-poster]');
    const status = section.querySelector('[data-al-study-status]');
    if (!button) return;
    button.addEventListener('click', async () => {
      button.disabled = true;
      status.textContent = section.dataset.loading;
      let viewer;
      try {
        await Promise.race([loadViewer(), new Promise((_,reject)=>setTimeout(()=>reject(new Error('Timeout')),20000))]);
        viewer = section.querySelector('template').content.firstElementChild.cloneNode(true);
        await new Promise((resolve,reject) => {
          const timeout = setTimeout(()=>reject(new Error('Timeout')),30000);
          viewer.addEventListener('load',()=>{clearTimeout(timeout);resolve();},{once:true});
          viewer.addEventListener('error',()=>{clearTimeout(timeout);reject(new Error('Model unavailable'));},{once:true});
          viewer.style.position = 'absolute'; viewer.style.inset = '0'; viewer.style.opacity = '0';
          poster.parentElement.append(viewer);
        });
        poster.hidden = true; viewer.style.opacity = '1'; viewer.style.height = 'calc(100% - 48px)';
        status.textContent = section.dataset.readyText;
        viewer.focus();
      } catch (_) {
        viewer?.remove(); button.disabled = false;
        status.textContent = section.dataset.error;
      }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
